import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  amountSlider: {
    padding: '8px 16px 0',
    width: '100%',
    boxSizing: 'border-box',
    '& .MuiSlider-root': {
      color: theme.palette.loading.main,
    },
    '& .MuiSlider-rail': {
      backgroundColor: theme.palette.bgSecondary.main,
      opacity: 1,
    },
    '& .MuiSlider-valueLabel': {
      backgroundColor: theme.palette.labraText.tertiary,
      fontSize: 12,
      lineHeight: '16px',
    },
  },
  amountBounds: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  bound: {
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
  },
}))
